module.exports = __webpack_public_path__ + "static/media/楷の木.acfcd613.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/楷の木.png
// module id = 320
// module chunks = 10